import { styled, TableCell } from "@mui/material";

export const MyHeadCellStyled = styled(TableCell)(
    ({ theme }) => ({
        color: theme.palette.primary.contrastText,
    })
);